<template>
  <div class="pc-index-container">
    <div class="content-wrapper">
      <!-- 左侧背景区域 -->
      <div class="left-section">
        <img src="/static/images/ctruck/banner.png" alt="背景图" class="banner-image" />
      </div>

      <!-- 右侧表单区域 -->
      <div class="right-section">
        <div class="form-card">
          <h1 class="form-title">联合重卡防伪验证系统</h1>
          
          <!-- 查询表单 -->
          <div v-if="!showResult" class="form-content">
            <input 
              v-model="antiCode" 
              @input="handleInput"
              type="text" 
              maxlength="19"
              class="input-field" 
              placeholder="请输入16位防伪数码"
            />
            
            <button 
              @click="queryAnti" 
              class="query-button"
              :disabled="isLoading"
            >
              {{ isLoading ? '查询中...' : '输入查询' }}
            </button>
          </div>

          <!-- 查询结果 -->
          <div v-if="showResult" class="result-content">
            <div class="result-box">
              <div class="result-item">
                <span class="result-label">您查询的数码为：</span>
                <span class="result-code">{{ queryResult.code }}</span>
              </div>
              <div class="result-message" v-html="queryResult.message"></div>
            </div>
            <button 
              @click="goBack" 
              class="back-button"
            >
              返回
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- 加载提示 -->
    <div v-show="isLoading" class="loading-overlay">
      <div class="loading-content">
        <img src="/static/images/loadding.gif" alt="加载中" />
      </div>
    </div>
  </div>
</template>

<script>
import { getAntiData } from '../../api/api'

export default {
  name: 'CTruckPCIndex',
  data() {
    return {
      antiCode: '',
      isLoading: false,
      eno: '138476474577', // 企业编号，根据实际情况调整
      showResult: false,
      queryResult: {
        code: '',
        message: ''
      }
    }
  },
  methods: {
    handleInput() {
      // 每4位数字后自动添加空格，方便用户阅读
      this.antiCode = this.antiCode.replace(/(\w{4})(?=\w)/g, '$1 ')
    },
    queryAnti() {
      const code = this.antiCode.replace(/\s+/g, '')
      
      if (!code) {
        alert('请输入16位防伪数码')
        return
      }
      
      if (code.length !== 16) {
        alert('请输入正确的16位防伪码')
        return
      }
      
      this.isLoading = true
      
      getAntiData(code, this.eno).then(res => {
        this.isLoading = false
        const data = res.data
        
        // 格式化显示查询码（每4位加空格）
        const formattedCode = code.replace(/(\w{4})(?=\w)/g, '$1 ')
        
        // 特殊场景：数码不存在300106
        if (data && (data.code == '300106' || data.code == 300106 || (data.data && (data.data.code == '300106' || data.data.code == 300106)))) {
          this.queryResult = {
            code: formattedCode,
            message: '您所查询的防伪码不存在，特别提示您谨防假冒，或核对后重新输入。'
          }
          this.showResult = true
          return
        }
        
        if (data == null || data.code == '500') {
          this.queryResult = {
            code: formattedCode,
            message: '防伪查询失败，请联系管理员'
          }
          this.showResult = true
        } else if (data.data && data.data.replyData) {
          // 使用返回的 replyData 字段
          this.queryResult = {
            code: formattedCode,
            message: data.data.replyData
          }
          this.showResult = true
        } else if (data.message) {
          // 如果没有 replyData，使用 message 字段
          this.queryResult = {
            code: formattedCode,
            message: data.message
          }
          this.showResult = true
        } else {
          this.queryResult = {
            code: formattedCode,
            message: '查询结果异常，请联系管理员'
          }
          this.showResult = true
        }
      }).catch(err => {
        this.isLoading = false
        console.error(err)
        const formattedCode = code.replace(/(\w{4})(?=\w)/g, '$1 ')
        this.queryResult = {
          code: formattedCode,
          message: '查询异常，请联系管理员'
        }
        this.showResult = true
      })
    },
    goBack() {
      this.showResult = false
      this.antiCode = ''
      this.queryResult = {
        code: '',
        message: ''
      }
    }
  }
}
</script>

<style scoped>
.pc-index-container {
  width: 100%;
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 40px;
  box-sizing: border-box;
  background: #f5f5f5;
}

.content-wrapper {
  max-width: 1400px;
  max-height: 800px;
  width: 100%;
  height: 100%;
  display: flex;
  gap: 0;
  overflow: hidden;
  border-radius: 12px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
  background: #ffffff;
  box-sizing: border-box;
}

/* 左侧背景区域 */
.left-section {
  flex: 0 0 60%;
  max-width: 60%;
  position: relative;
  overflow: hidden;
}

.banner-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

/* 右侧表单区域 */
.right-section {
  flex: 1;
  min-width: 500px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f5f5f5;
  padding: 40px;
  box-sizing: border-box;
  flex-shrink: 0;
}

.form-card {
  width: 100%;
  max-width: 480px;
  min-height: 360px;
  background: #ffffff;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  padding: 40px 40px;
  box-sizing: border-box;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
  display: flex;
  flex-direction: column;
}

.form-title {
  font-size: 24px;
  font-weight: 600;
  color: #333333;
  text-align: center;
  margin: 20px 0 25px 0;
  letter-spacing: 1px;
}

.form-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 20px;
  flex: 1;
  justify-content: center;
}

.input-field {
  width: 100%;
  max-width: 100%;
  height: 50px;
  padding: 0 16px;
  border: 1px solid #e0e0e0;
  border-radius: 6px;
  font-size: 16px;
  color: #333333;
  text-align: center;
  box-sizing: border-box;
  outline: none;
  transition: border-color 0.3s;
}

.input-field:focus {
  border-color: #4a90e2;
}

.input-field::placeholder {
  color: #999999;
}

.query-button {
  width: 100%;
  max-width: 100%;
  height: 50px;
  background: #000000;
  color: #ffffff;
  border: none;
  border-radius: 6px;
  font-size: 16px;
  font-weight: 500;
  cursor: pointer;
  transition: background-color 0.3s, opacity 0.3s;
  letter-spacing: 1px;
  text-align: center;
}

.query-button:hover:not(:disabled) {
  background: #333333;
}

.query-button:active:not(:disabled) {
  background: #1a1a1a;
}

.query-button:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

/* 查询结果样式 */
.result-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 15px;
  width: 100%;
  flex: 1;
  justify-content: flex-start;
  padding-top: 5px;
}

.result-box {
  width: 100%;
  background: #ffffff;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  padding: 15px 25px;
  box-sizing: border-box;
  text-align: left;
}

.result-item {
  margin-bottom: 12px;
  line-height: 1.5;
  white-space: nowrap;
  overflow: hidden;
}

.result-label {
  font-size: 16px;
  color: #333333;
  display: inline;
}

.result-code {
  font-size: 16px;
  font-weight: bold;
  color: #333333;
  margin-left: 5px;
  display: inline;
}

.result-message {
  font-size: 15px;
  color: #666666;
  line-height: 1.6;
  white-space: pre-line;
}

.result-message h2 {
  font-size: 18px;
  font-weight: bold;
  color: #333333;
  margin: 10px 0;
}

.result-message h4 {
  font-size: 16px;
  color: #333333;
  margin: 0 0 10px 0;
}

.result-message p {
  margin: 10px 0;
  color: #666666;
}

.back-button {
  width: 100%;
  height: 50px;
  background: #000000;
  color: #ffffff;
  border: none;
  border-radius: 6px;
  font-size: 16px;
  font-weight: 500;
  cursor: pointer;
  transition: background-color 0.3s;
  letter-spacing: 1px;
}

.back-button:hover {
  background: #333333;
}

.back-button:active {
  background: #1a1a1a;
}

/* 加载提示 */
.loading-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.3);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
}

.loading-content {
  background: #ffffff;
  border-radius: 8px;
  padding: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.loading-content img {
  width: 40px;
  height: 40px;
}
</style>


// WEBPACK FOOTER //
// src/components/CTruck/PCIndex.vue